// import React from "react";
// import { Navigate, Route } from "react-router-dom";

// import { useProfile } from "../Hooks/UserHooks";

// const AuthProtected = (props) => {
//   const { userProfile, loading } = useProfile();

//   /*
//     redirect is un-auth access protected routes via url
//     */

//   // if (!userProfile && loading) {
//   //   return (
//   //     <Navigate to={{ pathname: "/login", state: { from: props.location } }} />
//   //   );
//   // }

//   return <>{props.children}</>;
// };

// const AccessRoute = ({ component: Component, ...rest }) => {
//   return (
//     <Route
//       {...rest}
//       render={props => {
//         return (<> <Component {...props} /> </>);
//       }}
//     />
//   );
// };

// export { AuthProtected, AccessRoute };



import React from "react";
import { Navigate,Route } from "react-router-dom";
import { jwtDecode } from "jwt-decode"; // Importing jwtDecode as a named export

const AuthProtected = (props) => {
  // Retrieve user details from localStorages
  const token = sessionStorage.getItem("token");


  /*
    Redirect to login page if the user is not authenticated
    */

 
if (!token) {
    return <Navigate to="/login" />;
  }

  
  // Render children if authenticated
  return <>{props.children}</>;
};



const AccessRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        return (
          <>
            <Component {...props} />
          </>
        );
      }}
    />
  );
};

export { AuthProtected, AccessRoute };
